// Copyright (c) Move Closer 2022.

import { ComponentsStructureConfig } from '../../../../support/mixins'

/**
 * Service capable of defining application Possible Order Statuses
 *
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface IOrderStatusesService {
  addStatuses (config: ComponentsStructureConfig): void
  getStatuses (): Array<string>
  getHighlightedStatuses (): Array<string>
  getRetryStatuses (): Array<string>
  getReturnStatuses (): Array<string>
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum StatusModuleConfigEntry {
  HighlightedOrderStatuses = 'highlightedOrderStatuses',
  PossibleOrderStatuses = 'possibleOrderStatuses',
  RetryOrderStatuses = 'retryOrderStatuses',
  ReturnOrderStatuses = 'returnOrderStatuses'
}

export const OrderStatusesServiceType = Symbol.for('IOrderStatusesService')
